//=================================================
//    summary: DCP 忘記密碼 視窗 -- Hook
//
//    remarks: 000 Tim 2021/10/12 Create
//             001 Tim 2022/11/02 加入 多重登入 阻擋視窗 機制
//================================================
import React, { useState, useEffect } from 'react'
import cssForgotPassword from './ForgotPassword.module.scss'
import parse from 'html-react-parser'
import {LoadingMask, AlertWindow, CredentialMultiInWindow, GlobalLibs, NetworkLibs, RoutePathLibs, PackageVariablesLibs} from 'bc-react-package'

// #region State Member Variables
let mstrStateUserName = ""
let mstrStateClassName = ""
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false
let mblnIfNeed2GoToApplicationHomePage = null

let mobjCallParam = null
let mstrEmailSentClassName = ""
// #endregion Member Variables

// #region Enumeration
const EntranceTypeEnum = {
    "Forgot": 1,
    "EmailSent": 2
}
// #endregion Enumeration

const COMP_NAME = "ForgotPassword"

function ForgotPassword(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [userName, setUserName] = useState("")
    const [className, setClassName] = useState("")
    const [entranceType, setEntranceType] = useState(EntranceTypeEnum.Forgot)

    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)

    const [showOnFocusTitleForClassID, setShowOnFocusTitleForClassID] = useState(null)
    const [showOnFocusTitleForUserName, setShowOnFocusTitleForUserName] = useState(null)
    

    // #endregion Init State

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")
        mblnInitialized = true
        mblnIfNeed2GoToApplicationHomePage = RoutePathLibs.CheckIfNeed2GoToApplicationHomePage(props.history)
        console.log(COMP_NAME + "mblnIfNeed2GoToApplicationHomePage: ", mblnIfNeed2GoToApplicationHomePage)
        mstrStateUserName = userName
        mstrStateClassName = className
        mstrEmailSentClassName = ""
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update className
    useEffect(() => {
        mstrStateClassName = className
    }, [className])

    // Update userName
    useEffect(() => {
        mstrStateUserName = userName
    }, [userName])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            let objWindowRefs = {
                OpenLoadingMask: OpenLoadingMask,
                CloseLoadingMask: CloseLoadingMask,
                ShowAlert: ShowAlert,
                ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
            }
            // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
            GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)
        }

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            if (!mblnIfNeed2GoToApplicationHomePage)
            {
                // AAALibs.UnRegisterCallerWindownFuncRefs()
                GlobalLibs.UnRegisterCallerWindownFuncRefs()
            }
            mblnInitialized = false
            mstrEmailSentClassName = ""
        }
    }, [props.history])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 註冊 按鈕
    remarks: 000 Tim 2021/10/12 Create
    ===========================================*/
    function BackToLoginOnTapHandler()
    {
        console.log(COMP_NAME + ".BackToLoginOnTapHandler: ")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        RoutePathLibs.Route2Path(props.history, "/Login")
    } // end of BackToLoginOnTapHandler

    /*===========================================
    summary: 點選 送出 按鈕
    remarks: 000 Tim 2021/10/29 Create
    ===========================================*/
    function SubmitOnTapHandler()
    {
        console.log(COMP_NAME + ".SubmitOnTapHandler: ")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        ExecuteForgotPassword()
    } // end of SubmitOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler

    /*===========================================
    summary: 輸入框 鍵盤離開事件
    remarks: 000 Tim 2021/10/12 Create
    ===========================================*/
    function InputKeyUpHandler(e)
    {
        console.log(COMP_NAME + ".InputKeyUpHandler: ", e)

        if (e.keyCode === 13)
        {
            e.preventDefault()
            e.target.blur() // 避免彈出帳密錯誤的Alert Message時 使用者又再按Enter 再次觸發此事件
        }
    } // end of InputKeyUpHandler

    /*===========================================
    summary: 班級名稱 改變 事件
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function ClassIDChangeHandler(e)
    {
        console.log(COMP_NAME + ".ClassIDChangeHandler: ", e)
        setClassName(e.target.value)
    } // end of ClassIDChangeHandler

    /*===========================================
    summary: 使用者名稱 改變 事件
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function UserNameChangeHandler(e)
    {
        console.log(COMP_NAME + ".UserNameChangeHandler: ", e)
        setUserName(e.target.value)
    } // end of UserNameChangeHandler


    function ClassIDOnFocusHandler(Event)
    {
        const FUNC_NAME = "ClassIDOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        setShowOnFocusTitleForClassID(true)

        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function ClassIDOnBlurHandler(Event)
    {
        const FUNC_NAME = "ClassIDOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForClassID(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_ClassIDPlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForClassID(false)
        }
    }

    function UserNameOnFocusHandler(Event)
    {
        const FUNC_NAME = "UserNameOnFocusHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        console.log(COMP_NAME + "." + FUNC_NAME + " Event:", Event)
        setShowOnFocusTitleForUserName(true)

        Event.target.placeholder = "" // 將 placeholder 設為空字串
    }

    function UserNameOnBlurHandler(Event)
    {
        const FUNC_NAME = "UserNameOnBlurHandler"
        console.log(COMP_NAME + "." + FUNC_NAME)

        if(Event.target.value.trim() !== "")
        {
            // 有輸入字
            Event.target.placeholder = ""
            setShowOnFocusTitleForUserName(true)
        }
        else
        {
            // 無輸入任何字
            Event.target.placeholder = window.gAppUI.LBL_UserNamePlaceHolder // 將 placeholder 還原
            setShowOnFocusTitleForUserName(false)
        }
    }

    // #endregion Other EventHandler
    
    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow
    // #endregion LoadingMask and Alert Functions

    // #region Other Functions
    /*===========================================
    summary: 執行 忘記密碼 流程
    remarks: 000 Tim 2021/10/29 Create
    ===========================================*/
    function ExecuteForgotPassword()
    {
        let strClassName = mstrStateClassName.trim()
        let strUserName = mstrStateUserName.trim()

        var blnValidData = false;
        if (strUserName !== "") // 非空白
        {
            blnValidData = true;
        }
        else
        {
            // If UserName is empty, show alert
            let objAlertObject = {
                Header: null,
                Body: window.gAppUI.MSG_Alert_Msg_EmailIsFormatFail,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }

            ShowAlert(objAlertObject)
        }

        if (blnValidData) 
        {
            mobjCallParam = {
                "SysType": window.gSession.App.SysType,
                "ClassName": strClassName,
                "Email": strUserName
            }

            ResetForgotPassword()
        }  
    } // end of ExecuteForgotPassword
    // #endregion Other Functions

    // #region Get ClassName

    function GetClsOnFocusTitle(ShowOnFocusTitle)
    {
        const FUNC_NAME = "GetClsOnFocusTitle"
        console.log(COMP_NAME + "." + FUNC_NAME)

        let objCls = null
        if(ShowOnFocusTitle)
        {
            objCls = cssForgotPassword.divInputOnFocusTitle
        }
        else
        {
            objCls = cssForgotPassword.divHidden
        }
        return objCls
    }

    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 忘記密碼 重設密碼 資料寫入完畢
    remarks: 000 Tim 2021/10/29 Create
    ===========================================*/
    function ResetForgotPasswordAfterProcess()
    {
        console.log(COMP_NAME + ".ResetForgotPasswordAfterProcess: ")

        mstrEmailSentClassName = mobjCallParam.ClassName

        setEntranceType(EntranceTypeEnum.EmailSent)

        mobjCallParam = null
    } // end of ResetForgotPasswordAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 忘記密碼 重設密碼
    remarks: 000 Tim 2021/10/12 Create
    ===========================================*/
    function ResetForgotPassword()
    {        
        let objRetryFuncRef = ResetForgotPassword
        
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = ResetForgotPasswordCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY
            
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_ResetForgotPassword)

            let objCallData = {
                "Func": "ResetForgotPassword",
                "SysType": mobjCallParam.SysType,  
                "ClassName": mobjCallParam.ClassName,
                "Email": mobjCallParam.Email
            }
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of ResetForgotPassword

    /*===========================================
    summary: 忘記密碼 重設密碼 Callback
    remarks: 000 Tim 2021/10/12 Create
             001 Tim 2021/10/29 增加錯誤訊息處理
    ===========================================*/
    function ResetForgotPasswordCallback(Return)
    {        
        // Close Loading mask
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_ResetForgotPassword_No
        let strErrorTitle = window.gAppUI.ERR_ResetForgotPassword_Title
        let strErrMsg = window.gAppUI.ERR_ResetForgotPassword_Msg
        let blnExceptionError = false
        // end of customize
        
        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // -140068
                case window.gConst.WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_COULDNOT_FIND:    
                    blnExceptionError = true
                    strErrorTitle = ""
                    strErrMsg = window.gAppUI.ERR_ResetForgotPassword_CouldNotFind_Msg + ' (' + Return.CalledErrNo.toString() + ') '
                    break

                // 新增的錯誤處理      Tim20.04.13
                // -140180 155 ResetForgotPassword:     帳戶不允許更改密碼
                case window.gConst.WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_NOT_ALLOWED_CHANGE_PASSWORD:
                    blnExceptionError = true
                    strErrorTitle = "";
                    strErrMsg = window.gAppUI.ERR_ResetForgotPassword_NotAllowedChangePassword_Msg;
                    break;
                // 新增的錯誤處理      Tim20.04.13
                // -140171 ResetForgotPassword:     沒點選 認證連結
                // -140181 ResetForgotPassword:     沒認證Email
                case window.gConst.WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_NOT_YET_CLICK_VERIFY_LINK:
                case window.gConst.WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_EMAIL_NOT_VERIFIED:
                    blnExceptionError = true
                    strErrorTitle = "";
                    strErrMsg = window.gAppUI.ERR_ResetForgotPassword_NotVerified_Msg;
                    break;
                // -140182 ResetForgotPassword:     如果使用者輸入 classid+username 他沒有輸入信箱->跳錯
                case window.gConst.WEB_GATEWAY_RETURN_ERR_RESET_FORGOT_PASSWORD_EMAIL_NOT_EXISTED:
                    blnExceptionError = true
                    strErrorTitle = "";
                    strErrMsg = window.gAppUI.ERR_ResetForgotPassword_EmailNotExisted_Msg;
                    break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            if (blnExceptionError)
            {
                // 有需要 另外跳 錯誤訊息
                console.log("ResetForgotPasswordCallback: ExceptionError")

                let objAlertObject = {
                    Header: strErrorTitle,
                    Body: strErrMsg,
                    ShowCloseButton: false,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            } // end of if (blnExceptionError)

            console.log("ResetForgotPasswordCallback: ErrNo: ", Return.ErrNo)
            console.log("ResetForgotPasswordCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("ResetForgotPasswordCallback Return.Data: ", Return.Data)

            ResetForgotPasswordAfterProcess()
        }
    } // end of ResetForgotPasswordCallback
    // #endsregion Web Service

    // #region Render元件
    /*===========================================
    summary: 返回登入按鈕 顯示Component
    remarks: 000 Tim 2021/10/12 Create
    ===========================================*/
    function ComponentBackToLoginButton() 
    {   
        return(
            <div className={cssForgotPassword.btnBackToLogin} onClick={() => BackToLoginOnTapHandler()}>
                {window.gAppUI.LBL_BackToLogin}
            </div>
        )
    } // end of ComponentBackToLoginButton

    /*===========================================
    summary: 送出按鈕 顯示Component
    remarks: 000 Tim 2021/10/12 Create
    ===========================================*/
    function ComponentSubmitButton() 
    {   
        return(
            <div className={cssForgotPassword.btnSubmit} onClick={() => SubmitOnTapHandler()}>
                {window.gAppUI.LBL_ForgotPasswordSubmit}
            </div>
        )
    } // end of ComponentSubmitButton
    
    /*===========================================
    summary: 訊息 顯示Component
    remarks: 000 Tim 2021/10/12 Create
             001 Tim 2021/10/29 支援 EmailSent 顯示
    ===========================================*/
    function ComponentMessgage({EntranceType}) 
    {
        let objBlock = null

        if (EntranceType === EntranceTypeEnum.Forgot)
        {
            objBlock =  <div className={cssForgotPassword.divMessage}>
                            {window.gAppUI.MSG_ForgotPassword}
                        </div>
        }
        else
        {
            let strMsg = window.gAppUI.MSG_Alert_EmailSent;

            if (mstrEmailSentClassName !== "")
            {
                strMsg = strMsg.replace("@UserName@", "\"" + mstrEmailSentClassName + "\"")
            }
            else
            {
                strMsg = strMsg.replace("@UserName@", "your email")
            }

            objBlock =  <div className={cssForgotPassword.divMessage4EmailSent}>
                            {parse(strMsg)}
                        </div>
        }

        return(
            <React.Fragment>
                {objBlock}
            </React.Fragment>
        )
    } // end of ComponentMessgage

    /*===========================================
    summary: 標題 顯示Component
    remarks: 000 Tim 2021/10/12 Create
             001 Tim 2021/10/29 Create
    ===========================================*/
    function ComponentTitle({EntranceType})
    {   
        let objBlock = null

        if (EntranceType === EntranceTypeEnum.Forgot)
        {
            objBlock =  <React.Fragment>
                            <div className={cssForgotPassword.divTitle}>
                                {window.gAppUI.LBL_ForgotPassword}
                            </div>
                            <div className={cssForgotPassword.divSubTitle}>
                                {window.gAppUI.LBL_ForgotPasswordSub}
                            </div>
                        </React.Fragment>
        }
        else
        {
            objBlock =  <React.Fragment>
                            <div className={cssForgotPassword.divTitle}>
                                {window.gAppUI.LBL_EmailSent}
                            </div>
                        </React.Fragment>
        }

        return(
            <React.Fragment>
                {objBlock}
            </React.Fragment>
        )
    } // end of ComponentTitle
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Button Area 的顯示
    remarks: 000 Tim 2021/10/12 Create
    ===========================================*/
    function RenderButtonAreaWrapper(StateEntranceType)
    {
        let objBlock = null

        if (StateEntranceType === EntranceTypeEnum.Forgot)
        {
            objBlock =  <React.Fragment>
                            {ComponentSubmitButton()}

                            {ComponentBackToLoginButton()}
                        </React.Fragment>
        }
        else
        {
            objBlock =  <React.Fragment>
                            {ComponentBackToLoginButton()}
                        </React.Fragment>
        }

        return(
            <div className={cssForgotPassword.divButtonArea}>
                {objBlock}
            </div>
        )
    } // end of RenderButtonAreaWrapper

    /*===========================================
    summary: InputUserName 顯示
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function RenderInputUserNameWrapper(StateUserName) 
    {   
        return(
            <div className={cssForgotPassword.divInput4UserName} onKeyUp={InputKeyUpHandler}>
                <label htmlFor="txtUserName" className={cssForgotPassword.divHidden}>
                    {window.gAppUI.LBL_UsernameEmailPlaceHolder}
                </label>
                <input
                    id="txtUserName"
                    className={cssForgotPassword.txtInput}
                    type="email"
                    value={StateUserName}
                    placeholder={window.gAppUI.LBL_UsernameEmailPlaceHolder}
                    onChange={(event) => UserNameChangeHandler(event)}
                    required
                    autoComplete="true"
                    onFocus={(event) => UserNameOnFocusHandler(event)}
                    onBlur={(event) => UserNameOnBlurHandler(event)}
                    />
                <div className={GetClsOnFocusTitle(showOnFocusTitleForUserName)}>
                    {window.gAppUI.LBL_UsernameEmailPlaceHolder}
                </div>
            </div>
        )
    } // end of RenderInputUserNameWrapper

    /*===========================================
    summary: InputClassName 顯示
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function RenderInputClassNameWrapper(StateClassName) 
    {   
        return(
            <div className={cssForgotPassword.divInput4ClassName} onKeyUp={InputKeyUpHandler}>
                <label htmlFor="txtClassID" className={cssForgotPassword.divHidden}>
                    {window.gAppUI.LBL_ClassIDPlaceHolder}
                </label>
                <input
                    id="txtClassID"
                    className={cssForgotPassword.txtInput}
                    type="text"
                    value={StateClassName}
                    placeholder={window.gAppUI.LBL_ClassIDPlaceHolder}
                    onChange={(event) => ClassIDChangeHandler(event)}
                    required
                    autoComplete="true"
                    onFocus={(event) => ClassIDOnFocusHandler(event)}
                    onBlur={(event) => ClassIDOnBlurHandler(event)}
                    />
                <div className={GetClsOnFocusTitle(showOnFocusTitleForClassID)}>
                    {window.gAppUI.LBL_ClassIDPlaceHolder}
                </div>
            </div>
        )
    } // end of RenderInputClassNameWrapper

    /*===========================================
    summary: Render 輸入框區域 的顯示
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function RenderInputWrapper(StateEntranceType)
    {
        if (StateEntranceType === EntranceTypeEnum.Forgot)
        {
            return(
                <div className={cssForgotPassword.divInputArea}>
                    {RenderInputClassNameWrapper(className)}
                    
                    {RenderInputUserNameWrapper(userName)}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderInputWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function RenderContentWrapper(StateEntranceType)
    {
        return (
            <div className={cssForgotPassword.divContent}>
                <ComponentTitle EntranceType={StateEntranceType}/>

                {RenderInputWrapper(StateEntranceType)}

                <ComponentMessgage EntranceType={StateEntranceType}/>

                {RenderButtonAreaWrapper(StateEntranceType)}
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            return (
                <>
                    <div className={cssForgotPassword.divMain}>
                        <div className={cssForgotPassword.divBG}/>
                        <div className={cssForgotPassword.divMask}/>

                        {RenderContentWrapper(entranceType)}
                    </div>

                    <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                    <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
                    <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default ForgotPassword